import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, } from '@mui/material';
import { useState } from 'react';
import { styled } from '../../utils';
import { FormGrid } from '../FormGrid';
import { Icon } from '../Icon';
export const AccordionGroup = ({ accordionGroupList }) => {
    const [expandedPanelIndex, setExpandedPanelIndex] = useState(null);
    return (_jsx("div", { children: accordionGroupList.map((accordion, index) => (_jsxs(MuiAccordionStyled, { expanded: expandedPanelIndex === index, className: expandedPanelIndex === null
                ? ''
                : expandedPanelIndex - 1 === index
                    ? 'bottomBorderRounded'
                    : expandedPanelIndex + 1 === index
                        ? 'topBorderRounded'
                        : '', onKeyDown: (event) => {
                if (event.code === 'Space' && expandedPanelIndex !== index) {
                    setExpandedPanelIndex(expandedPanelIndex === index ? null : index);
                }
            }, children: [_jsx(MuiAccordionSummaryStyled, { expandIcon: !accordion.expandDisabled && (_jsx(Icon, { fontSize: "small", variant: accordion.summaryIcon ?? 'pencil', onClick: () => setExpandedPanelIndex(expandedPanelIndex === index ? null : index), role: "button" })), role: "region", children: _jsxs(SummaryContentStyled, { rowGap: 2, columnGap: 2, children: [accordion.summaryTitle, expandedPanelIndex !== index && accordion.summaryDescription] }) }), accordion.details] }, index))) }));
};
const MuiAccordionStyled = styled(MuiAccordion)(({ theme }) => ({
    borderLeft: `1px solid ${theme.palette.groupPrimary.dove}`,
    borderRight: `1px solid ${theme.palette.groupPrimary.dove}`,
    '&:first-of-type': {
        borderTop: `1px solid ${theme.palette.groupPrimary.dove}`,
    },
    '&:last-of-type': {
        borderBottom: `1px solid ${theme.palette.groupPrimary.dove}`,
        '&:after': {
            display: 'none',
        },
    },
    '&.bottomBorderRounded': {
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        borderBottom: `1px solid ${theme.palette.groupPrimary.dove}`,
        '&:after': {
            display: 'none',
        },
    },
    '&.topBorderRounded': {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        borderTop: `1px solid ${theme.palette.groupPrimary.dove}`,
    },
    boxShadow: 'none',
    '&.Mui-expanded': {
        border: 'none',
        marginBottom: theme.spacing(5),
        '&:after': {
            display: 'none',
        },
    },
    '&:before': {
        display: 'none',
    },
    '&:after': {
        display: 'flex',
        height: '1px',
        opacity: 1,
        content: '""',
        margin: `0 ${theme.spacing(2)}`,
        backgroundColor: theme.palette.groupPrimary.dove,
    },
}));
const MuiAccordionSummaryStyled = styled(MuiAccordionSummary)(({ theme, expandIcon }) => ({
    '&:hover:not(.Mui-disabled)': {
        cursor: 'auto',
    },
    '&.Mui-expanded': {
        padding: 0,
        transition: 'none',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
        color: theme.palette.primary.dark,
        cursor: 'pointer',
        '&.Mui-expanded': {
            transform: 'none',
            display: 'none',
        },
    },
    paddingRight: expandIcon ? '1rem' : '2rem',
}));
const SummaryContentStyled = styled(FormGrid)(({ theme }) => ({
    width: '100%',
    alignItems: 'baseline',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    [theme.breakpoints.up('sm')]: {
        gridTemplateColumns: '1fr 3fr',
    },
}));
